import React, { Component } from "react";
import { InfoArea } from "../../PlantListStyle";
import Graph from "./Graph";
import styled from "styled-components";
import Divider from "../../../../commons/components/divider/Divider";
import MS from "../../../../commons/services/Moment";
import { FLOW_MODE_KEY, FLOW_MODE_NAME, PANEL_ED_KEY, PANEL_ED_NAME, PRESSURE_MODE_KEY, PRESSURE_MODE_NAME, SEARCH_TIME_OPTION, TANK_CONDUCTIVITY_KEY, TANK_CONDUCTIVITY_NAME, TANK_LEVEL_KEY, TANK_LEVEL_NAME, TANK_PH_KEY, TANK_PH_NAME, TIME_KEY } from "./graphModel";
import { fetchMockBatteryLogData } from "../mock/batteryGraphApi";
import { withTranslation } from "react-i18next";


class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      batteryId: props.match.params.batteryId,
      searchDate: { name: "date", date: MS.current("YYYY-MM-DD") },
      searchTime: ["00:00:00", "03:00:00"],
      tankLevel: [],
      tankPh: [],
      tankConductivity: [],
      modeFlow: [],
      modePressure: [],
      panelEd: [],
      categories: [],
    }

    this.onChangeSearch = this.onChangeSearchDate.bind(this);
    this.onChangeSearchTime = this.onChangeSearchTime.bind(this);
  }

  componentDidMount() {
    this.getGraphData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.searchDate !== this.state.searchDate || prevState.searchTime !== this.state.searchTime) {
      this.getGraphData();
    }
  }

  onChangeSearchDate(name, date) {
    // console.log(name, date);
    this.setState({ searchDate: { name, date } });
  }
  onChangeSearchTime(time) {
    // console.log(time.split(","));
    this.setState({ searchTime: time.split(",") });
  }
  async getGraphData() {
    const { batteryId, searchDate, searchTime } = this.state;
    const fromDate = searchDate?.date + " " + searchTime[0];
    const toDate = searchDate?.date + " " + searchTime[1];
    // console.log("getGraph data: ", batteryId, fromDate, toDate);
    const batterySerialNos = [batteryId];

    const data = await fetchMockBatteryLogData({ batterySerialNos, fromDate, toDate });
    // console.log("fetched data: ", data);

    setChartData(data);

    this.setState(setChartData(data));
  }

  render() {
    const { 
      batteryId, 
      searchDate, 
      searchTime,
      tankLevel,
      tankPh,
      tankConductivity,
      modeFlow,
      modePressure,
      panelEd,
      categories,
    } = this.state;
    const { t } = this.props;
    // console.log(batteryId);
    return (
      <>
        <div className="page-tit gray">
          <div className="container f-stack">
            <h2 className="tit">{t('key491')}</h2>
          </div>
        </div>
        <InfoArea>
          <Graph 
            title={"TANK LEVEL"} 
            date={searchDate?.date} 
            onChangeSearch={(name, date) => this.onChangeSearchDate(name, date)} 
            selectOptions1={SEARCH_TIME_OPTION}
            onChangeSearchTime={(value) => this.onChangeSearchTime(value)}
            series={tankLevel}
            categories={categories}
            defaultSelectValue1={SEARCH_TIME_OPTION[0].value}
          />
          <Divider />
          <Graph title={"TANK PH"}
            series={tankPh}
            categories={categories}
          />
          <Divider />
          <Graph title={"TANK CONDUCTIVITY"}
            series={tankConductivity}
            categories={categories}
          />
          <Divider />
          <Graph title={t('key660')}
            series={modeFlow}
            categories={categories}
          />
          <Divider />
          <Graph title={t('key495')}
            series={modePressure}
            categories={categories}
          />
          <Divider />
          <Graph title={"PANEL / ED"}
            series={panelEd}
            categories={categories}
          />
        </InfoArea>
      </>
    )
  }
}

export default withTranslation()(Index);

function setChartData(data) {
  if (!data || data?.lenght === 0) return;

  const tankLevel = [];
  const tankPh = [];
  const tankConductivity = [];
  const modeFlow = [];
  const modePressure = [];
  const panelEd = [];
  const categories = [];

  TANK_LEVEL_KEY.forEach((key, idx) => {
    tankLevel.push({
      name: TANK_LEVEL_NAME[idx],
      data: data.map((item) => item[key]),
    });
  });

  TANK_PH_KEY.forEach((key, idx) => {
    tankPh.push({
      name: TANK_PH_NAME[idx],
      data: data.map((item) => item[key]),
    });
  });

  TANK_CONDUCTIVITY_KEY.forEach((key, idx) => {
    tankConductivity.push({
      name: TANK_CONDUCTIVITY_NAME[idx],
      data: data.map((item) => item[key]),
    });
  });

  PANEL_ED_KEY.forEach((key, idx) => {
    panelEd.push({
      name: PANEL_ED_NAME[idx],
      data: data.map((item) => item[key]),
    });
  });

  FLOW_MODE_KEY.forEach((key, idx) => {
    modeFlow.push({
      name: FLOW_MODE_NAME[idx],
      data: data.map((item) => item[key]),
    });
  });

  PRESSURE_MODE_KEY.forEach((key, idx) => {
    modePressure.push({
      name: PRESSURE_MODE_NAME[idx],
      data: data.map((item) => item[key]),
    });
  });

  data.forEach((item) => {
    categories.push(item.time);
  });

  // console.log("tankLevel: ", tankLevel);
  // console.log("tankPh: ", tankPh);
  // console.log("tankConductivity: ", tankConductivity);
  // console.log("modeFlow: ", modeFlow);
  // console.log("modePressure: ", modePressure);
  // console.log("panelEd: ", panelEd);
  
  return {
    tankLevel,
    tankPh,
    tankConductivity,
    modeFlow,
    modePressure,
    panelEd,
    categories,
  }
}